import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "@ws-react-query";
import {
  updateEngagementRequirementByPayeeId,
  WSPayeeEngagementRequirementUpdateRequest
} from "../../../services/payeeEngagement/updateEngagementRequirementByPayeeId";
import {
  QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
  QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
  QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE
} from "../keys";
import { QUERY_PAYEE } from "../../payee/keys";
import { QUERY_PAYEE_ROWS } from "../../search/payee/queries/usePayeeRowsQuery";
import { QUERY_PAYEE_ROWS_SUMMARY } from "../../search/payee/queries/usePayeeRowsSummaryQuery";
import { IPayeeEngagementResponse } from "@wingspanhq/payments/dist/interfaces";
import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";
import {
  QUERY_REQUIREMENTS_FULL_LIST,
  QUERY_REQUIREMENTS_FULL_LIST_SIZE,
  QUERY_REQUIREMENTS_LIST
} from "../../requirements/keys";

export interface IChangeRequirementStatusRequest {
  payeeId: string;
  engagementId: string;
  requirementId: string;
  request: WSPayeeEngagementRequirementUpdateRequest;
}

export const useUpdatePayeeEngagementRequirement = () => {
  const xWingspanPayerId = useXWingspanPayerId();

  return useWSMutation<
    IPayeeEngagementResponse,
    WSServiceError,
    IChangeRequirementStatusRequest
  >(
    async ({ payeeId, engagementId, requirementId, request }) => {
      return await updateEngagementRequirementByPayeeId(
        payeeId,
        engagementId,
        requirementId,
        request,
        xWingspanPayerId
      );
    },
    {
      dependencies: [
        QUERY_REQUIREMENTS_FULL_LIST,
        QUERY_REQUIREMENTS_FULL_LIST_SIZE,
        QUERY_REQUIREMENTS_LIST
      ],
      awaitDependencies: (_result, variables) => [
        QUERY_PAYEE_ENGAGEMENT_BY_PAYEE_ID,
        QUERY_PAYEE_ENGAGEMENTS_LIST_SIZE,
        QUERY_PAYEE_ENGAGEMENTS_LIST_BY_PAYEE_ID_ALL,
        [QUERY_PAYEE, variables.payeeId],
        QUERY_PAYEE_ROWS,
        QUERY_PAYEE_ROWS_SUMMARY
      ]
    }
  );
};
